import { isTokenValid, useToken } from '@ori/auth';
import type { TranslationsContext } from '@ori/i18n';
import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import {
  defaultTranslations as BPDefaultTranslations,
  translationsNamespace as BPTranslationsNamespace,
} from '../constants/defaultTranslations_simplified-registration-BrandPartner';
import {
  defaultTranslations as VIPDefaultTranslations,
  translationsNamespace as VIPTranslationsNamespace,
} from '../constants/defaultTranslations_simplified-registration-VIPCustomer';
import { useConfiguration } from '../contexts';

export const I18nContainer: FC<PropsWithChildren> = ({ children }) => {
  const { currentLanguage, staticApiUrl, tenant, registrationType } = useConfiguration();

  const { token } = useToken();

  const correctTranslationNameSpace =
    registrationType === 'Consultant' ? BPTranslationsNamespace : VIPTranslationsNamespace;
  const correctDefalutTranslations = registrationType === 'Consultant' ? BPDefaultTranslations : VIPDefaultTranslations;

  const translationProps: TranslationsContext = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: (error) => {
        console.log('Error occured while loading translations.', String(error));
      },
      tenant,
      token,
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [correctTranslationNameSpace]: correctDefalutTranslations,
    },
  };

  if (!isTokenValid(token)) {
    return null;
  }

  return (
    <TranslationsProvider {...translationProps}>
      <TranslationsNamespaceProvider namespace={correctTranslationNameSpace}>{children}</TranslationsNamespaceProvider>
    </TranslationsProvider>
  );
};
